import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaAngleLeft,
  FaAngleRight,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tooltip,
  DialogContent,
  Box,
  Button,
  IconButton,
  Typography,
  Checkbox,
  Dialog,
} from "@mui/material";
import logo from "../../Assets/img/logo.svg";
import { ReactComponent as HomeIcon } from "../../Assets/img/icons/Recent.svg";
import { ReactComponent as ProfileIcon } from "../../Assets/img/icons/Profile.svg";
import { ReactComponent as ID } from "../../Assets/img/icons/ID.svg";
import { ReactComponent as Digital } from "../../Assets/img/icons/Digital Marketing.svg";
import { ReactComponent as CardIcon } from "../../Assets/img/icons/Card icon.svg";
import { ReactComponent as ContactIcon } from "../../Assets/img/icons/Contact.svg";
import { ReactComponent as DigitalIcon } from "../../Assets/img/icons/email sign.svg";
import { ReactComponent as EventIcon } from "../../Assets/img/icons/Event Manage.svg";
import { ReactComponent as CatalogIcon } from "../../Assets/img/icons/Catalog.svg";
import { ReactComponent as DiscountIcon } from "../../Assets/img/icons/discount.svg";
import { ReactComponent as DashboardIcon } from "../../Assets/img/icons/Dashboard.svg";
import { MdOutlinePhoneIphone } from "react-icons/md";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import useApi from "../Utilities/useAPI";
import { useProfileContext } from "../ProfileDetailContext";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";
import QRCodeStyling from "qr-code-styling";
import { useSelector } from "react-redux";
import { getAllEvents, getExplore, getFeeds, getMyFeeds, getRegisteredAttendees, setExploreType } from "../../Redux/Reducers/communityReducer";
import { useDispatch } from "react-redux";

const Sidebar = ({ isSidebarOpen, toggleSidebar, setActive }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const exploreType = useSelector((state) => state?.community?.exploreType);
  // Track which specific "coming-soon" item was last clicked
  const [activeItem, setActiveItem] = useState(null);

  // Reset activeItem when navigating away from /coming-soon
  useEffect(() => {
    if (location.pathname !== "/coming-soon") {
      setActiveItem(null);
    }
  }, [location.pathname]);

  // Updated isActive: for /coming-soon routes, also match by itemKey
  const isActive = (path, itemKey = null) => {
    if (path === "/coming-soon" && itemKey) {
      return location.pathname === "/coming-soon" && activeItem === itemKey;
    }
    return location.pathname === path;
  };

  const { PersonalDetails, setPersonalDetails } = useProfileContext();
  const { callApiFunction } = useApi();

  const [open, setOpen] = React.useState(false);
  const [opennew, setOpennew] = React.useState(false);
  const [hover, setHover] = React.useState(false);
  const [hovernew, setHovernew] = React.useState(false);
  const [hoverCards, setHoverCards] = React.useState(false);
  const [submenuPosition, setSubmenuPosition] = useState({ top: 0, left: 0 });
  const [submenuPositionnew, setSubmenuPositionnew] = useState({
    top: 0,
    left: 0,
  });
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipIdOpen, setTooltipIdOpen] = useState(false);
  const [tooltipCardsOpen, setTooltipCardsOpen] = useState(false);
  const [openCards, setOpenCards] = useState(false);
  const digitalIdentityRef = useRef(null);
  const [submenuPositionCards, setSubmenuPositionCards] = useState({
    top: 0,
    left: 0,
  });
  const idref = useRef(null);
  const cardsRef = useRef(null);

  // QR Code related states and refs
  const [openMobLightBox, setOpenMobLightBox] = useState(false);
  const qrCodeRef = useRef(null);
  const qrCodeInstance = useRef(null);

  const [openExplore, setOpenExplore] = React.useState(false);
  const [hoverExplore, setHoverExplore] = React.useState(false);
  const [submenuPositionExplore, setSubmenuPositionExplore] = useState({ top: 0, left: 0 });
  const [tooltipExploreOpen, setTooltipExploreOpen] = useState(false);
  const exploreRef = useRef(null);
  // Inside your Sidebar component, add these selectors or context hooks
  const ProfessionalEducation =
    useSelector((state) => state?.ProfileArray?.educationData?.data) || [];
  const ProfessionalExperience =
    useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];

  // Initialize QR code when dialog opens
  useEffect(() => {
    if (openMobLightBox) {
      // Small timeout to ensure DOM is ready
      setTimeout(() => {
        if (qrCodeRef.current) {
          // Clear previous content
          qrCodeRef.current.innerHTML = '';

          // Create new QR code instance with black color
          qrCodeInstance.current = new QRCodeStyling({
            width: 200,
            height: 200,
            data: "https://play.google.com/store/apps/details?id=com.neoin&hl=en_IN",
            image: logo,
            dotsOptions: {
              color: "#000000",
              type: "rounded"
            },
            backgroundOptions: {
              color: "#ffffff",
            },
            imageOptions: {
              crossOrigin: "anonymous",
              margin: 5,
              imageSize: 0.4,
              hideBackgroundDots: true
            },
            cornersSquareOptions: {
              type: "extra-rounded",
              color: "#000000"
            },
            cornersDotOptions: {
              type: "dot",
              color: "#000000"
            },
            qrOptions: {
              typeNumber: 0,
              mode: "Byte",
              errorCorrectionLevel: "Q"
            }
          });

          // Append to DOM
          qrCodeInstance.current.append(qrCodeRef.current);
        }
      }, 100);
    }
  }, [openMobLightBox]);

  const handleMouseEnter = () => {
    if (digitalIdentityRef.current) {
      const rect = digitalIdentityRef.current.getBoundingClientRect();
      setSubmenuPosition({ top: rect.top, left: rect.right });
    }
    setTooltipOpen(true);
  };

  const handleMouseEnterCards = () => {
    if (cardsRef.current) {
      const rect = cardsRef.current.getBoundingClientRect();
      setSubmenuPositionCards({ top: rect.top, left: rect.right });
    }
    setTooltipCardsOpen(true);
  };

  const handleMouseLeaveDigital = () => {
    setHover(false);
  };

  const handleMouseLeaveID = () => {
    setHovernew(false);
  };

  const handleDigitalClick = () => {
    toggleSidebar();
    setActive("digital-identity");
    setTooltipOpen(false);
    setHovernew(false);
    setHoverCards(false);
    setOpen(true);
  };

  const handleCardsClick = () => {
    toggleSidebar();
    setActive("cards");
    setTooltipCardsOpen(false);
    setHovernew(false);
    setOpenCards(true);
    setHover(false);
    setOpennew(false);
  };

  const handleMouseLeave = () => {
    setTooltipOpen(false);
  };

  const handleMouseEnternew = () => {
    if (idref.current) {
      const rect = idref.current.getBoundingClientRect();
      setSubmenuPositionnew({ top: rect.top, left: rect.right });
    }
    setTooltipIdOpen(true);
  };

  const handleMouseLeavenew = () => {
    setTooltipIdOpen(false);
  };

  const handleItemIDClick = () => {
    toggleSidebar();
    setActive("ID");
    setTooltipIdOpen(false);
    setHover(false);
    setHoverCards(false);
    setOpennew(true);
    setOpenCards(false);
  };

  const handleItemClick = (component) => {
    setActive(component);
    toggleSidebar(false);
  };

  const handleClick = () => {
    setOpennew(false);
    setOpenCards(false);
    setOpen(!open);
  };

  const handleClicknew = () => {
    setOpenCards(false);
    setOpennew(!opennew);
    setOpen(false);
  };

  const handleMouseLeaveCards = () => {
    setTooltipCardsOpen(false);
  };

  const handleProfileTabClick = async () => {
    setActive("myprofile");
  };

  const handleMouseEnterExplore = () => {
    if (exploreRef.current) {
      const rect = exploreRef.current.getBoundingClientRect();
      setSubmenuPositionExplore({ top: rect.top, left: rect.right });
    }
    setTooltipExploreOpen(true);
  };

  const handleMouseLeaveExplore = () => {
    setTooltipExploreOpen(false);
  };

  const handleExploreClick = () => {
    toggleSidebar();
    setActive("explore");
    setTooltipExploreOpen(false);
    setOpenExplore(!openExplore);
    // Close other sections
    setOpenCards(false);
    setOpen(false);
    setOpennew(false);
  };

  const handleClickExplore = () => {
    setOpenExplore(!openExplore);
    setOpenCards(false);
    setOpen(false);
    setOpennew(false);
  };

  // Update your existing Cards handler to properly manage state
  const handleClickCards = () => {
    setOpenCards(!openCards);
    setOpenExplore(false);
    setOpen(false);
    setOpennew(false);
  };



  // Helper function to check verification status
  const checkProfessionalVerification = () => {
    // Check if any education is verified
    const hasVerifiedEducation = ProfessionalEducation?.some(
      edu => edu.is_verified === true
    );

    // Check if any current work experience is verified
    const hasVerifiedCurrentWork = ProfessionalExperience?.some(
      exp => exp.is_currently_working === true && exp.is_verified === true
    );

    return hasVerifiedEducation || hasVerifiedCurrentWork;
  };



  // Handler for Personal click - no verification needed
  // const handlePersonalClick = (e) => {
  //   e.preventDefault();
  //   dispatch(setExploreType("PERSONAL"));
  //   navigate("/community");
  //   toggleSidebar(); // Close sidebar after navigation
  // };

  const handleCommunityClick = async (type) => {
    if (type === "personal") {
      await dispatch(setExploreType("PERSONAL"));
      const payload = { type: exploreType, my_posts: false };
      await dispatch(getFeeds(payload));
      await dispatch(getAllEvents({ page: 0, type: "PERSONAL" }));
      await dispatch(getExplore({ type: "PERSONAL" }));
      await dispatch(getMyFeeds({ type: "PERSONAL" }));
      await dispatch(getRegisteredAttendees({ type: "PERSONAL" }));
      navigate("/community");
      toggleSidebar();
    } else {
      // Professional verification check
      const isVerified = checkProfessionalVerification();
      if (isVerified) {
        await dispatch(setExploreType("PROFESSIONAL"));
         const payload = { type: exploreType, my_posts: false };
      await dispatch(getFeeds(payload));
      await dispatch(getAllEvents({ page: 0, type: "PROFESSIONAL" }));
      await dispatch(getExplore({ type: "PROFESSIONAL" }));
      await dispatch(getMyFeeds({ type: "PROFESSIONAL" }));
      await dispatch(getRegisteredAttendees({ type: "PROFESSIONAL" }));
        navigate("/community");
        toggleSidebar();
      } else {
        if (window.openSnackbar) {
          window.openSnackbar(
            "Verify at least one education or company to access the professional community.",
            "warning"
          );
        } else {
          alert("You need to have at least one verified education or be currently working in a verified company to access professional community");
        }
        toggleSidebar();
      }
    }
  };

  // Handler for Professional click - with verification
  // const handleProfessionalClick = (e) => {
  //   e.preventDefault();

  //   const isVerified = checkProfessionalVerification();
  //   if (isVerified) {
  //     // If verified, dispatch PROFESSIONAL and navigate to community
  //     dispatch(setExploreType("PROFESSIONAL"));
  //     navigate("/community");
  //     toggleSidebar(); // Close sidebar after navigation
  //   } else {
  //     // Show warning and redirect to profile
  //     if (window.openSnackbar) {
  //       window.openSnackbar(
  //         "Verify at least one education or company to access the professional community.",
  //         "warning"
  //       );
  //     } else {
  //       alert("You need to have at least one verified education or be currently working in a verified company to access professional community");
  //     }

  //     // Navigate to professional profile page to add verification
  //     // navigate("/myprofile?mainTab=professional_profile");
  //     toggleSidebar(); // Close sidebar after navigation
  //   }
  // };

  return (
    <div className={`sidebar ${isSidebarOpen ? "" : "collapsed"}`}>
      <div className="sidebar-header">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
      </div>

      <div className="sidebar-content">
        <div className="left-right-icon-new flex-center">
          {isSidebarOpen ? (
            <FaAngleLeft onClick={toggleSidebar} />
          ) : (
            <FaAngleRight onClick={toggleSidebar} />
          )}
        </div>
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          component="nav"
          className={`sidebar-Nav-content ${isSidebarOpen ? "" : "collapsed"}`}
        >
          <Tooltip
            title="Home"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/home"
              className={`flex-center sidebar-link ${isActive("/home") ? "active" : ""
                } ${isSidebarOpen ? "" : "d-flex flex-column"}`}
              onClick={() => setActive("home")}
            >
              <ListItemIcon>
                <HomeIcon
                  className={`img-active ${isActive("/home") ? "active" : ""}`}
                />
              </ListItemIcon>
              <ListItemText primary={isSidebarOpen ? "Home" : ""} />
            </ListItemButton>
          </Tooltip>

          <Tooltip
            title=" My Profile"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/myprofile"
              className={`flex-center sidebar-link ${isActive("/myprofile") ? "active" : ""
                } ${isSidebarOpen ? "" : "d-flex flex-column"}`}
              onClick={handleProfileTabClick}
            >
              <ListItemIcon>
                <ProfileIcon
                  className={`img-active ${isActive("/myprofile") ? "active" : ""
                    }`}
                />
              </ListItemIcon>
              <ListItemText primary={isSidebarOpen ? "Profile" : ""} />
            </ListItemButton>
          </Tooltip>

          {/* <Tooltip
            title="Explore"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/community"
              className={`flex-center sidebar-link ${isActive("/community") ? "active" : ""
                } ${isSidebarOpen ? "" : "d-flex flex-column"}`}
              onClick={handleProfileTabClick}
            >
              <ListItemIcon>
                <RocketLaunchRoundedIcon
                  className={`img-active ${isActive("/community") ? "active" : ""
                    }`}
                />
              </ListItemIcon>
              <ListItemText primary={isSidebarOpen ? "Explore" : ""} />
            </ListItemButton>
          </Tooltip> */}

          {isSidebarOpen ? (
            <>
              <ListItemButton onClick={handleClickExplore}>
                <ListItemIcon>
                  <RocketLaunchRoundedIcon
                    className={`img-active ${isActive("/community") ? "active" : ""}`}
                  />
                </ListItemIcon>
                <ListItemText primary="Explore" />
                {openExplore ? <FaAngleUp /> : <FaAngleDown />}
              </ListItemButton>
              <Collapse in={openExplore} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    component="a"
                    className={`ms-4 sidebar-link ${isActive("/community") && exploreType === "PERSONAL" ? "active" : ""}`}
                    onClick={() => handleCommunityClick("personal")}
                  >
                    <ListItemText primary="Personal" />
                  </ListItemButton>

                  <ListItemButton
                    sx={{ pl: 4 }}
                    component="a"
                    className={`ms-4 sidebar-link ${isActive("/community") && exploreType === "PROFESSIONAL" ? "active" : ""}`}
                    onClick={() => handleCommunityClick("professional")}
                  >
                    <ListItemText primary="Professional" />
                  </ListItemButton>
                </List>
              </Collapse>
            </>
          ) : (
            // Collapsed state for Explore
            <>
              <ListItemButton
                className={`sidebar-link ${isActive("/community") ? "active" : ""}`}
                onClick={handleExploreClick}
                ref={exploreRef}
                onMouseEnter={handleMouseEnterExplore}
                onMouseLeave={handleMouseLeaveExplore}
              >
                <ListItemIcon>
                  <RocketLaunchRoundedIcon
                    className={`img-active ${isActive("/community") ? "active" : ""}`}
                  />
                </ListItemIcon>
                <ListItemText primary="" />
              </ListItemButton>
            </>
          )}

          {isSidebarOpen ? (
            <>
              <ListItemButton onClick={handleClicknew}>
                <ListItemIcon>
                  <ID
                    className={`img-active ${isActive("/ID") ? "active" : ""}`}
                  />
                </ListItemIcon>
                <ListItemText primary={isSidebarOpen ? "ID" : ""} />
                {opennew ? <FaAngleUp /> : <FaAngleDown />}
              </ListItemButton>

              <Collapse in={opennew} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/coming-soon"
                    className={`ms-4 sidebar-link ${isActive("/coming-soon", "public-id") ? "active" : ""
                      }`}
                    onClick={() => { handleItemClick("/coming-soon"); setActiveItem("public-id"); }}
                  >
                    <ListItemText primary={isSidebarOpen ? "Public ID" : ""} />
                  </ListItemButton>

                  <ListItemButton
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/id"
                    className={`ms-4 sidebar-link ${isActive("/id") ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("ID")}
                  >
                    <ListItemText primary={isSidebarOpen ? "Private ID" : ""} />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/countrySelecting"
                    className={`ms-4 sidebar-link ${isActive("/country-selecting") ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("country-selecting")}
                  >
                    <ListItemText primary={isSidebarOpen ? "KYC" : ""} />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/documents"
                    className={`ms-4 sidebar-link ${isActive("/documents") ? "active" : ""}`}
                    onClick={() => { handleItemClick("/documents"); setActiveItem("documents"); }}
                  >
                    <ListItemText primary={isSidebarOpen ? "Documents" : ""} />
                  </ListItemButton>
                </List>
              </Collapse>
            </>
          ) : (
            <>
              <ListItemButton
                ref={idref}
                component={Link}
                to="#0"
                className={`sidebar-link ${isActive("/ID") ? "active" : ""}`}
                onClick={handleItemIDClick}
                onMouseEnter={handleMouseEnternew}
                onMouseLeave={handleMouseLeavenew}
              >
                <ListItemIcon>
                  <ID
                    className={`img-active ${isActive("/ID") ? "active" : ""}`}
                  />
                </ListItemIcon>
                <ListItemText primary={isSidebarOpen ? "ID" : ""} />
              </ListItemButton>
            </>
          )}

          {isSidebarOpen ? (
            <>
              <ListItemButton onClick={handleClickCards}>
                <ListItemIcon>
                  <CardIcon
                    className={`img-active ${isActive("/cards") ? "active" : ""
                      }`}
                  />
                </ListItemIcon>
                <ListItemText primary={isSidebarOpen ? "Cards" : ""} />
                {openCards ? <FaAngleUp /> : <FaAngleDown />}
              </ListItemButton>
              <Collapse in={openCards} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    component="a"
                    href="/cards"
                    className={`ms-4 sidebar-link ${isActive("/my-cards") ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("my-cards")}
                  >
                    <ListItemText primary={isSidebarOpen ? "My Cards" : ""} />
                  </ListItemButton>

                  <ListItemButton
                    sx={{ pl: 4 }}
                    component="a"
                    href="/AllBusinessCard"
                    className={`ms-4 sidebar-link ${isActive("/business-cards") ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("business-cards")}
                  >
                    <ListItemText
                      primary={isSidebarOpen ? "Business Cards" : ""}
                    />
                  </ListItemButton>
                </List>
              </Collapse>
            </>
          ) : (
            <>
              <ListItemButton
                className={`sidebar-link ${isActive("/cards") ? "active" : ""}`}
                onClick={handleCardsClick}
                ref={cardsRef}
                onMouseEnter={handleMouseEnterCards}
                onMouseLeave={handleMouseLeaveCards}
              >
                <ListItemIcon>
                  <CardIcon
                    className={`img-active ${isActive("/cards") ? "active" : ""
                      }`}
                  />
                </ListItemIcon>
                <ListItemText primary={isSidebarOpen ? "Cards" : ""} />
              </ListItemButton>
            </>
          )}

          <Tooltip
            title="Contact"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/contacts"
              className={`sidebar-link ${isActive("/") ? "active" : ""}`}
              onClick={() => { setActive("contacts") }}
            >
              <ListItemIcon>
                <ContactIcon />
              </ListItemIcon>
              <ListItemText primary={isSidebarOpen ? "Contacts" : ""} />
            </ListItemButton>
          </Tooltip>

          {/* This is the important part for Digital Identity */}
          {isSidebarOpen ? (
            <>
              <ListItemButton onClick={handleClick}>
                <ListItemIcon>
                  <DigitalIcon
                    className={`img-active ${isActive("/digital-identity") ? "active" : ""
                      }`}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={isSidebarOpen ? "Digital Identity" : ""}
                />
                {open ? <FaAngleUp /> : <FaAngleDown />}
              </ListItemButton>

              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    href="/digital-identity"
                    className={`ms-4 sidebar-link ${isActive("/digital-identity") ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("digital-identity")}
                  >
                    <ListItemText
                      primary={isSidebarOpen ? "Email Signature" : ""}
                    />
                  </ListItemButton>

                  <ListItemButton
                    sx={{ pl: 4 }}
                    component={Link}
                    to="VirtualBackground"
                    className={`ms-4 sidebar-link ${isActive("virtual-background") ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("virtual-background")}
                  >
                    <ListItemText
                      primary={isSidebarOpen ? "Virtual Background" : ""}
                    />
                  </ListItemButton>

                  <ListItemButton
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/coming-soon"
                    className={`ms-4 sidebar-link ${isActive("/coming-soon", "digital-signature") ? "active" : ""
                      }`}
                    onClick={() => { handleItemClick("/coming-soon"); setActiveItem("digital-signature"); }}
                  >
                    <ListItemText
                      primary={isSidebarOpen ? "Digital Signature" : ""}
                    />
                  </ListItemButton>

                  <ListItemButton
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/letterheads"
                    className={`ms-4 sidebar-link ${isActive("/letterheads") ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("/letterheads")}
                  >
                    <ListItemText
                      primary={isSidebarOpen ? "Letter Head" : ""}
                    />
                  </ListItemButton>

                  <ListItemButton
                    sx={{ pl: 4 }}
                    component={Link}
                    to="/notes"
                    className={`ms-4 sidebar-link ${isActive("/notes") ? "active" : ""
                      }`}
                    onClick={() => handleItemClick("/notes")}
                  >
                    <ListItemText
                      primary={isSidebarOpen ? "Secured Notes" : ""}
                    />
                  </ListItemButton>
                </List>
              </Collapse>
            </>
          ) : (
            <>
              <ListItemButton
                ref={digitalIdentityRef}
                className={`sidebar-link ${isActive("/digital-identity") ? "active" : ""
                  }`}
                onClick={handleDigitalClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <ListItemIcon>
                  <DigitalIcon
                    className={`img-active ${isActive("/digital-identity") ? "active" : ""
                      }`}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={isSidebarOpen ? "Digital Identity" : ""}
                />
              </ListItemButton>
            </>
          )}

          <Tooltip
            title="Events"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/coming-soon"
              className={`sidebar-link ${isActive("/coming-soon", "events") ? "active" : ""}`}
              onClick={() => { setActive("/coming-soon"); setActiveItem("events"); }}
            >
              <ListItemIcon>
                <EventIcon
                  className={`img-active ${isActive("/coming-soon", "events") ? "active" : ""
                    }`}
                />
              </ListItemIcon>
              <ListItemText primary={isSidebarOpen ? "Event Management" : ""} />
            </ListItemButton>
          </Tooltip>

          <Tooltip
            title="Marketing"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/coming-soon"
              className={`sidebar-link ${isActive("/coming-soon", "marketing") ? "active" : ""
                }`}
              onClick={() => { setActive("marketing"); setActiveItem("marketing"); }}
            >
              <ListItemIcon>
                <Digital
                  className={`img-active ${isActive("/coming-soon", "marketing") ? "active" : ""
                    }`}
                />
              </ListItemIcon>
              <ListItemText
                primary={isSidebarOpen ? "Digital Marketing" : ""}
              />
            </ListItemButton>
          </Tooltip>

          <Tooltip
            title="Discounts"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/discount"
              className={`sidebar-link ${isActive("/discount") ? "active" : ""
                }`}
              onClick={() => setActive("discounts")}
            >
              <ListItemIcon>
                <DiscountIcon
                  className={`img-active ${isActive("/discounts") ? "active" : ""
                    }`}
                />
              </ListItemIcon>
              <ListItemText
                primary={isSidebarOpen ? "Offers & Discounts" : ""}
              />
            </ListItemButton>
          </Tooltip>

          <Tooltip
            title="Catalog"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/coming-soon"
              className={`sidebar-link ${isActive("/coming-soon", "catalog") ? "active" : ""}`}
              onClick={() => { setActive("catalog"); setActiveItem("catalog"); }}
            >
              <ListItemIcon>
                <CatalogIcon
                  className={`img-active ${isActive("/coming-soon", "catalog") ? "active" : ""
                    }`}
                />
              </ListItemIcon>
              <ListItemText primary={isSidebarOpen ? "Service Catalog" : ""} />
            </ListItemButton>
          </Tooltip>

          <Tooltip
            title="Dashboard"
            placement="right"
            disableHoverListener={isSidebarOpen}
          >
            <ListItemButton
              component={Link}
              to="/coming-soon"
              className={`sidebar-link ${isActive("/coming-soon", "dashboard") ? "active" : ""
                }`}
              onClick={() => { setActive("/coming-soon"); setActiveItem("dashboard"); }}
            >
              <ListItemIcon>
                <DashboardIcon
                  className={`img-active ${isActive("/coming-soon", "dashboard") ? "active" : ""
                    }`}
                />
              </ListItemIcon>
              <ListItemText primary={isSidebarOpen ? "Dashboard" : ""} />
            </ListItemButton>
          </Tooltip>
        </List>

        <div className="flex-center">
          {isSidebarOpen ? (
            <Button
              variant="contained"
              sx={{ backgroundColor: "#0044C6", marginBottom: "20px" }}
              onClick={() => setOpenMobLightBox(true)}
            >
              <MdOutlinePhoneIphone className="icon-color3 custom-icon" />
              GO TO MOBILE
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={() => setOpenMobLightBox(true)}
              sx={{
                backgroundColor: "#0044C6",
                width: "40px",
                height: "40px",
                margin: 0,
                padding: 0,
                maxWidth: "40px",
                minWidth: "40px",
              }}
            >
              <MdOutlinePhoneIphone className="icon-color3 custom-icon" />
            </Button>
          )}
        </div>
      </div>

      {openMobLightBox && (
        <Dialog
          open={openMobLightBox}
          onClose={() => {
            setOpenMobLightBox(false);
          }}
        >
          <DialogContent
            sx={{
              padding: "0",
              textAlign: "center",
              position: "relative",
              width: "354px",
              height: "460px",
              scrollbarWidth: "none",
            }}
          >
            <IconButton
              aria-label="close"
              onClick={() => {
                setOpenMobLightBox(false);
              }}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseRoundedIcon />
            </IconButton>
            <Typography
              className="mt-3 mb-1"
              variant="h6"
              component="div"
              sx={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Get the mobile app
            </Typography>
            <Typography
              variant="body2"
              component="div"
              sx={{ marginBottom: "20px" }}
              className="mx-4"
            >
              Scan the QR code to access your account on mobile.
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <div className="qr-outline-mobile flex-center">
                {/* Static Black QR Code Container */}
                <div
                  ref={qrCodeRef}
                  style={{
                    width: "200px",
                    height: "200px",
                    backgroundColor: "#f5f5f5",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                />
              </div>
              <div className="width250px d-flex flex-column justify-content-start ">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox />
                  <Typography variant="body2">
                    Don't show this again.
                  </Typography>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    className="text-left"
                    variant="body2"
                  >
                    You can manage this in the settings.
                  </Typography>
                </div>
              </div>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      {/* Submenu for Digital Identity when sidebar is collapsed */}
      {hover && !isSidebarOpen && (
        <div
          className="submenu visible"
          onMouseLeave={handleMouseLeaveDigital}
          style={{ top: submenuPosition.top, left: submenuPosition.left }}
        >
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 4 }}
              href="/digital-identity"
              className={`sidebar-link ${isActive("/digital-identity") ? "active" : ""
                }`}
              onClick={() => handleItemClick("digital-identity")}
            >
              <ListItemText primary="Email Signature" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to="VirtualBackground"
              className={`sidebar-link ${isActive("#0") ? "active" : ""}`}
              onClick={() => handleItemClick("#0")}
            >
              <ListItemText primary="Virtual Background" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to="#0"
              className={`sidebar-link ${isActive("#0") ? "active" : ""}`}
              onClick={() => handleItemClick("#0")}
            >
              <ListItemText primary="Digital Signature" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to="#0"
              className={`sidebar-link ${isActive("#0") ? "active" : ""}`}
              onClick={() => handleItemClick("#0")}
            >
              <ListItemText primary="Letter Head" />
            </ListItemButton>

            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to="/notes"
              className={`sidebar-link ${isActive("#0") ? "active" : ""}`}
              onClick={() => handleItemClick("#0")}
            >
              <ListItemText primary="Secured Notes" />
            </ListItemButton>
          </List>
        </div>
      )}

      {hovernew && !isSidebarOpen && (
        <div
          className="submenu visible"
          onMouseLeave={handleMouseLeaveID}
          style={{ top: submenuPositionnew.top, left: submenuPositionnew.left }}
        >
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to="#0"
              className={`sidebar-link ${isActive("#0") ? "active" : ""}`}
              onClick={() => handleItemClick("#0")}
            >
              <ListItemText primary="Public ID" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to="/id"
              className={`sidebar-link ${isActive("/id") ? "active" : ""}`}
              onClick={() => handleItemClick("id")}
            >
              <ListItemText primary="Private ID" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to="#0"
              className={`sidebar-link ${isActive("#0") ? "active" : ""}`}
              onClick={() => handleItemClick("#0")}
            >
              <ListItemText primary="Access" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to="/countrySelecting"
              className={`sidebar-link ${isActive("#0") ? "active" : ""}`}
              onClick={() => handleItemClick("country-selecting")}
            >
              <ListItemText primary="KYC" />
            </ListItemButton>

          </List>
        </div>
      )}

      {hoverCards && !isSidebarOpen && (
        <div
          className="submenu visible"
          onMouseLeave={() => setHoverCards(false)}
          style={{
            top: submenuPositionCards.top,
            left: submenuPositionCards.left,
          }}
        >
          <List component="div" disablePadding>
            <ListItemButton
              href="/cards"
              className={`sidebar-link ${isActive("/my-cards") ? "active" : ""
                }`}
              onClick={() => handleItemClick("my-cards")}
            >
              <ListItemText primary={isSidebarOpen ? "My Cards" : "My Cards"} />
            </ListItemButton>
            <ListItemButton
              href="/AllBusinessCard"
              className={`sidebar-link ${isActive("/business-cards") ? "active" : ""
                }`}
              onClick={() => handleItemClick("business-cards")}
            >
              <ListItemText
                primary={isSidebarOpen ? "Business Cards" : "Business Cards"}
              />
            </ListItemButton>
          </List>
        </div>
      )}
    </div>
  );
};

export default Sidebar;